<div class="container" style="margin-top:10%">
    <img class="img-not-found" [src]="imagePath" alt="icone: não encontrado">
</div>
<div class="container po-mt-5 ">
    <div class="text-not-found">
        Não encontrado
    </div>
</div>
<div class="po-md-12 po-text-center po-mt-1">
    <span>
        Recurso indisponível ou não encontrado
    </span>
</div>
<div class="button-not-found container po-mt-5 po-text-center">
    <po-button (p-click)="goToHome()" p-label="Voltar para o início"></po-button>
</div>